import styled from "styled-components";

export const SupportCenterContainer = styled.div(props => ({
    textAlign:"left",  
    fontSize:"1rem",
    "& p" :{
        textAlign: 'justify'
    }
}));